module.exports = __webpack_public_path__ + "assets/img/diag-service.34455bac.jpg";